export * from './use-question-image';
export * from './test-intro';

import Styles from './styles.module.less';

export const testIntroStyles = Styles;
